import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { NombreCientificoService } from './nombrecientifico.service';
import { HttpParams } from '@angular/common/http';
import { NombreCientificoItemResultsViewModel, NombreCientificoViewModel, FilterSearchingNombreCientificoViewModel } from './nombrecientifico.types';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';
import { EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

@Component({
    selector: 'app-nombrecientifico-list',
    templateUrl: './nombrecientifico-list.component.html',
})
export class NombrecientificoListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    IdCodigoEppo: number | null = null;

    resultNombreCientificos: NombreCientificoItemResultsViewModel;

    cols: any[];
    public isCollapsed = false;

    visibilitySpinner: boolean = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private nombreCientificoService: NombreCientificoService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.resultNombreCientificos = new NombreCientificoItemResultsViewModel();
    }

    ngOnInit() {
        this.form = this.fb.group({
            Descripcion: '',
            CodigoEppo: '',
            Favorito: EnumSiNoTodos.TODOS,
            SinAsignarEppo: EnumSiNoTodos.TODOS,
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Descripcion', header: 'Descripción' },
            { field: 'CodigoEppo', header: 'Código Eppo' },
            { field: 'Favorito', header: 'Favorito' },
        ];

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        if (
            this.nombreCientificoService.currentFilterNombreCientifico.Descripcion != '' ||
            this.nombreCientificoService.currentFilterNombreCientifico.CodigoEppo! ||
            this.nombreCientificoService.currentFilterNombreCientifico.Favorito != EnumSiNoTodos.TODOS ||
            this.nombreCientificoService.currentFilterNombreCientifico.SinAsignarEppo != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                Descripcion: this.nombreCientificoService.currentFilterNombreCientifico.Descripcion,
                IdCodigoEppo: this.nombreCientificoService.currentFilterNombreCientifico.CodigoEppo,
                Favorito: this.nombreCientificoService.currentFilterNombreCientifico.Favorito,
                SinAsignarEppo: this.nombreCientificoService.currentFilterNombreCientifico.SinAsignarEppo,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        //let params = new HttpParams();

        this.nombreCientificoService.currentFilterNombreCientifico.Descripcion = this.form.value.Descripcion;
        this.nombreCientificoService.currentFilterNombreCientifico.CodigoEppo = this.form.value.CodigoEppo;
        this.nombreCientificoService.currentFilterNombreCientifico.Favorito = this.form.value.Favorito;
        this.nombreCientificoService.currentFilterNombreCientifico.SinAsignarEppo = this.form.value.SinAsignarEppo;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('descripcion', this.form.value.Descripcion);
        params = params.append('codigoEppo', this.form.value.CodigoEppo);
        params = params.append('favorito', this.form.value.Favorito);
        params = params.append('sinAsignarEppo', this.form.value.SinAsignarEppo);

        this.loading = true;

        this.nombreCientificoService.getNombreCientificoPagedByFilter(params).subscribe(result => {
            this.resultNombreCientificos = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Descripcion: '',
            CodigoEppo: '',
            Favorito: EnumSiNoTodos.TODOS,
            SinAsignarEppo: EnumSiNoTodos.TODOS,
        });

        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultNombreCientificos = new NombreCientificoItemResultsViewModel();
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/especies/nombrescientificos/create']);
    }

    onEdit(item: NombreCientificoViewModel) {
        this.router.navigate(['/mantenimiento/especies/nombrescientificos/edit', item.Id]);
    }

    onDelete(item: NombreCientificoViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.nombreCientificoService.deleteNombreCientifico(item.Id).subscribe({
                    next: res => {
                        this.addSuccessMessage('Nombre cientí­fico eliminado correctamente');
                        this.onSearchButton();
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    CreateModel() {
        let model: FilterSearchingNombreCientificoViewModel = new FilterSearchingNombreCientificoViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.nombreCientificoService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
